module.exports = function (app) {
    app.directive('btsFooterMessage', ['$window', function ($window) {

        return {
            //template: require('./btsFooterMessage.html'),
            templateUrl: "forgot-password.appTemplate.html/chmhom/larg/directives/btsFooterMessage",
            restrict: 'A',
            replace: true,
            scope: {
                messageText: '=',
                headerText: '=',
                iconClass: '='
            }
        };
    }]);
};
